
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri",
      function () {
        return require("private-next-pages/pelatihan-mandiri/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri"])
      });
    }
  